const tabbableNode = /input|select|textarea|button|object/

function hidden(el) {
  // return if el has no width or height, or display is set to none
  return (
    (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
    el.style.display === "none" ||
    window.getComputedStyle(el, null).getPropertyValue("visibility") === "hidden"
  )
}

function visible(element) {
  let parentElement = element
  while (parentElement) {
    // if you've reached the body, break
    if (parentElement === document.body) break
    // if the parent element is hidden, return false
    if (hidden(parentElement)) return false
    // else set parentElement to its parentNode and continue the loop
    parentElement = parentElement.parentNode
  }
  return true
}

function focusable(element, isTabIndexNotNaN, checkVisibility) {
  const nodeName = element.nodeName.toLowerCase()
  // if element is a tabbableNode and not disabled, or a link with an href, or has a tabIndex
  const res =
    (tabbableNode.test(nodeName) && !element.disabled) ||
    (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN)
  // return true if the element passes the previous conditional and the element is visible
  return res && (!checkVisibility || visible(element))
}

function tabbable(element, checkVisibility) {
  let tabIndex = element.getAttribute("tabindex")
  // if element does not have a tabIndex, set tabIndex to undefined
  if (tabIndex === null) tabIndex = "undefined"
  // store if tabIndex is a number
  // eslint-disable-next-line no-restricted-globals
  const isTabIndexNaN = isNaN(tabIndex)
  // if tabIndex is not negative, return if the element is focusable
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN, checkVisibility)
}

function findTabbable(element, checkVisibility = true) {
  // return and array of all tabbable elements
  return (
    [].slice
      .call(element.querySelectorAll("*"), 0)
      // eslint-disable-next-line no-shadow
      .filter(element => tabbable(element, checkVisibility))
  )
}

function scopeTab({ node, event, first, last }) {
  // create an array of tabbable elements inside of node
  // eslint-disable-next-line no-shadow
  const tabList = findTabbable(node)
  const tabbableList = [first, ...tabList, last].filter(item => !!item)
  // if no tabbable elements in array, escape
  if (!tabbableList.length) {
    event.preventDefault()
    return
  }
  // find the first or last tabbable element depending on if the shift key is pressed
  const finalTabbable = tabbableList[event.shiftKey ? 0 : tabbableList.length - 1]
  // determine if the user is navigating out of the passed node and store it
  const leavingFinalTabbable =
    finalTabbable === document.activeElement ||
    // handle immediate shift+tab after opening with mouse
    node === document.activeElement
  // if not leaving, return
  if (!leavingFinalTabbable) return
  event.preventDefault()
  // target the opposite end of the tabbable array, from the finalTabbable element
  const target = tabbableList[event.shiftKey ? tabbableList.length - 1 : 0]
  // then focus
  target.focus()
}

const focusTools = {
  scopeTab,
  findTabbable
}
export default focusTools
